// import React from 'react';
import styled from 'styled-components';

const SectionHeading = styled.h1`
    font-family: "PT Sans";
    color: rgb(0, 114, 228);
    text-transform: uppercase;
    font-size: 36px;
    line-height: 0.667;
    text-align: center;
    padding: 10px 0 40px 0;
    
    // @media only screen and (min-width: 400px) {
    //     & {
    //         font-size: 32px;
    //         line-height: 42px;
    //     }

    `;

export default SectionHeading;